// src/assets/images.js
import heroHome from './heroHome.avif';
import home1 from './homeFirst.avif';
import transportHero from './transportHero.jpg'
import oficeHero from './oficeHero.webp'
import pochistvaneHero from './pochistvaneHero.avif'
import pochistvaneOne from './pochistvaneOne.avif'
import pochistvaneTwo from './pochistvaneTwo.avif'
import pochistvaneThree from './pochistvaneThree.avif'



export const IMAGES = {
  HeroHome: heroHome,
  Home1: home1,
  TransportHero: transportHero,
  OficeHero: oficeHero,
  PochistvaneHero: pochistvaneHero,
  PochistvaneOne: pochistvaneOne,
  PochistvaneTwo: pochistvaneTwo,
  PochistvaneThree: pochistvaneThree,
};